import React from 'react';
import styled from 'styled-components';
import { Column } from 'react-foundation';
import { Icon } from '../../components/Icon';
import { withDefaultProps } from '../../utils/reactUtils';

interface Props {
	icon: string;
	href: string;
	newWindow?: boolean;
	children: React.ReactNode;
}

const A = styled.a`
  display: block;
	color: #4c4c4c;
`;

const IconColumn = styled(Column)`
  text-align: center;
  padding: 1rem;
`;

IconColumn.defaultProps = {
	small: 12,
	medium: 4,
};

const ContentColumn = styled(Column)`
`;

ContentColumn.defaultProps = {
	small: 12,
	medium: 8,
};

const defaultProps: Partial<Props> = {
	newWindow: true
};

export const CustomerServiceSection: React.FC<Props> = withDefaultProps(defaultProps, (props: Props) => (
	<A className="row" href={props.href} target={props.newWindow ? '_blank' : undefined}>
		<IconColumn>
			{props.icon && <Icon name={props.icon} />}
		</IconColumn>
		<ContentColumn className="text-center-small">
			<h4>{React.Children.toArray(props.children)}</h4>
		</ContentColumn>
	</A>
));